// extracted by mini-css-extract-plugin
export default {"cont":"TeacherTable_cont__peR0P","table__cont":"TeacherTable_table__cont__Pu12Y","table":"TeacherTable_table__ICrRF","thead":"TeacherTable_thead__zpvkQ"};